import { useEffect, useRef, useState } from "react";
import SockJS from "sockjs-client";
import { Client, IMessage } from "@stomp/stompjs";

import { storage } from "../Utils/authStorage";
import { WS_BASE_URL } from "../Services/ApiClient";
import {
  EventLogResponseDTO,
  LIVE_EVENTS_TOPIC,
} from "../../Admin/Types/EventLogs";

export const useEventLogsStream = (
  enabled: boolean,
  onEvent: (event: EventLogResponseDTO) => void
) => {
  const [connected, setConnected] = useState(false);
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    if (!enabled) {
      setConnected(false);
      return;
    }

    const token = storage.getToken();
    if (!token) {
      setConnected(false);
      return;
    }

    const client = new Client({
      webSocketFactory: () => new SockJS(`${WS_BASE_URL}/ws`),
      connectHeaders: { Authorization: `Bearer ${token}` },
      reconnectDelay: 3000,

      onConnect: () => {
        setConnected(true);
        client.subscribe(LIVE_EVENTS_TOPIC, (message: IMessage) => {
          try {
            const event = JSON.parse(message.body) as EventLogResponseDTO;
            onEventRef.current(event);
          } catch (error) {
            console.error("EventLog parse error", error);
          }
        });
      },

      onWebSocketClose: () => {
        setConnected(false);
      },
      onStompError: () => {
        setConnected(false);
      },
    });

    client.activate();

    return () => {
      client.deactivate();
      setConnected(false);
    };
  }, [enabled]);

  return { connected };
};